import { format, Locale } from 'date-fns'
import { de, fr, enUS, pt, es, ru, ja, it } from 'date-fns/locale'

const getLocale = (lang?: string): Locale => {
    switch(lang) {
        case 'pt': return pt
        case 'de': return de
        case 'fr': return fr
        case 'it': return it
        case 'es': return es
        case 'ja': return ja
        case 'ru': return ru
        default: return enUS
    }
}

export const getDate = (d?: string, lang?: string) => d ? format(new Date(d.substring(0, 10)), 'd-MMM-yyyy', { locale: getLocale(lang) }) : null
